<template>
  <div class="checkoutContent"  v-if="isLogined" v-loading="loading" :element-loading-text="elementLoadingText">
    <div class="deliveryInfo">
      <div class="title">确认收货信息</div>
      <div class="deliveryContent">
        <div class="head">收货信息</div>
        <div class="content">
          <div v-if="isAddAddress" class="saveDeliveryAddress">
            <div class="addressInfo">
              <div class="deliveryInfo1">
                <div><span>*</span>收货人：</div><input type="text" placeholder="请输入收货人" v-model="msg.name">
                <div><span>*</span>手机号码：</div><input type="text" placeholder="请输入手机号码" v-model="msg.mobile">
              </div>
              <div class="deliveryInfo2">
                <div><span>*</span>所在地区：</div>
                <select v-model="msg.province" placeholder="请选择省份"  @change="changeProvince(msg.province)" >
                  <option v-for="item in provinces" :key="item.value" :label="item.name" :value="item.name" />
                </select>
                <select v-model="msg.city" placeholder="请选择城市"  @change="changeCity(msg.city)" >
                  <option v-for="item in cities" :key="item.value" :label="item.name" :value="item.name" />
                </select>
                <select v-model="msg.area" placeholder="请选择县/区" >
                  <option v-for="item in areas" :key="item.value" :label="item.name" :value="item.name" />
                </select>
              </div>
              <div class="deliveryInfo3">
                <div><span>*</span>详细地址：</div>
                <textarea rows="2"  placeholder="请输入详细地址" v-model="msg.address"></textarea>
              </div>
            </div>
            <div class="operate">
              <div class="deliveryDefault" >     
                <el-checkbox v-model="msg.isDefault">设置默认收货地址</el-checkbox>      
              </div>  
              <div class="deliverySaveBtn"> <input type="button" value="保存地址" @click="save"><input class="cancelBtn" type="button" value="取消" @click="cancelSave"></div>
            </div>
          </div>
          <div v-else class="deliveryAddressList"> 
             <table>
                <tr class="addressHead">
                  <th class="selectAddress"></th>
                  <th class="deliveryName">收货人</th>
                  <th class="location">所在地区</th>
                  <th class="address">详细地址</th>
                  <th class="mobile">手机</th>
                  <th class="operate">操作</th>
                </tr>
                <tr v-for="(item,i) in addList" :key="i">
                  <td>
                    <el-checkbox v-model="item.checked" @change="selectAddress(item.id)" :key="'select_'+item.id" ></el-checkbox>                    
                  </td>
                  <td>{{item.name}}</td>
                  <td>{{item.province}}{{item.city}}{{item.area}}</td>
                  <td>{{item.address}}</td>
                  <td>{{item.mobile}}</td>
                  <td>
                    <input type="button" v-if="item.isDefault" class="DefaultAddress" value="默认地址">
                    <input type="button" v-else class="DefaultAddress1" value="设置默认" @click="changeDef(item)" >                    
                  </td>
                </tr>
             </table>  
             <img class="notHaveDeliveryAddress" v-if="addList.length==0" src="http://img.static.knnnj.com/Default/dcb7cc98-a007-4f37-88cc-539fdaf24747.png" />
             <input type="button" class="addDeliveryAddress" value="添加新地址" @click="addAddress">     
          </div>   
        </div>
      </div>
    </div>
    <div class="helpFundInfo">
      <div class="title">订单帮扶</div>
      <div class="helpFundContent">
        <div class="head">订单帮扶金：<span>{{Number(totalHelpFund).toFixed(2)}}</span>    <input type="button" value="选择帮扶人员" @click="_selectVeteran"> </div>
        <div class="content">
          <div class="veteranPhoto" v-if="veteran && veteran.veteranId>0">
              <img class="photo" :src="veteran.photo" />
              <img v-if="veteran.sex==0||veteran.sex==false" class="sex" src="https://file-sz.fjjykj.com.cn/Supply/s6e13598728334b924712b04a842b4eef.png" />
              <img v-else class="sex" src="https://file-sz.fjjykj.com.cn/Supply/sd2ffec0974c7f31c402e31a89c6e4d8b.png" />
          </div>
          <div v-if="veteran && veteran.veteranId>0" class="veteranName">{{veteran.veteranName}}<span>{{veteran.age}}岁</span></div>
        </div>
      </div>
    </div>
    <div class="orderInfo">
      <div class="title">确认订单信息</div>
      <div class="orderContent">
        <table>
          <tr class="productHead">
            <th class="productName" colspan="2" >商品信息</th>
            <th class="productPrice">单价</th>
            <th class="productNum">数量</th>
            <th class="productTotal">总价</th>
            <th class="productPostFee">运费</th>
          </tr>
          <tr v-for="(item,i) in cartList" :key="'product_'+ item.postFee +i">
            <td class="productImage"><img @click="goodsDetails(item.productId)" :src="item.defaultImage"></td>
            <td>{{item.name}}({{item.specName}})</td>
            <td>￥{{Number(item.settlementPrice).toFixed(2)}}</td>
            <td><input type="number" v-model="item.num" @change="countPostFee" ></td>
            <td class="productListAmount">￥{{Number(item.settlementPrice*item.num).toFixed(2)}}</td>
            <td class="productListAmount" >￥{{Number(item.postFee).toFixed(2)}}</td>
          </tr>
        </table>
       <div class="sellerRemarks"><div>给卖家留言：</div><input type="text"  placeholder="给卖家留言" v-model="remarks"></div>
        <div class="orderfooter"> 
          <input type="button" value="去付款" @click="_submitOrder">
          <div class="orderAmount">￥{{Number(checkPrice).toFixed(2)}}</div>      
          <div class="payLabel">应付总额：</div>           
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <selectVeteran ref="selectVeteran" @seted="_getVeteran"></selectVeteran>
  </div>
  <div class="checkoutContent1" v-else>
    <div @click="toLogin()">亲,请先登陆</div>
  </div>
</template>
<style>
@import '../../styles/checkout.css';
</style>
<script> 
  import api from '@/api'
  import { mapMutations, mapState } from 'vuex'
  import { getAddressList, createOrEdit } from '@/api/deliveryAddress'
  import { submitOrder, calculatePostFee } from '@/api/order'
  import { getAreas} from '@/api/commonLookup' 
  import { getStore, setStore, removeStore  } from '@/utils/storage'
  import SelectVeteran from './components/SelectVeteran' 
  export default {
    data () {
      return {
        cartList: [],
        addList: [],
        addressId: 0,
        veteran:{
          veteranId:null,
          veteranName:'',
          sex:false,
          age:1,
        },      
        totalHelpFund:0,
        num: '', // 立刻购买
        productId: '',      
        remarks:'',//卖家留言   
        msg: {
          id: '',
          area:'',
          city:'',
          province:'',
          name: '',
          mobile: '',
          address: '',
          isDefault: false,    
        },
        orderTotal: 0,
        loading:false,
        elementLoadingText:"订单提交中,请稍后...",
        isCart:true,
        isAddAddress:false,
        provinces: [],
        cities: [],
        areas: [],
      }
    },
    computed: { 
      ...mapState(['isLogined']), 
      // 选中的总价格
      checkPrice () {
        let totalPrice = 0      
        this.cartList && this.cartList.forEach(item => {
          if(item.num<=0)
          {
             this.message('数量必须是大于0的整数')       
             item.num=1;
          }
          totalPrice += (item.num * item.settlementPrice) + item.postFee     
        })
        this.orderTotal = totalPrice   
        return totalPrice
      }
    },
    methods: {
      ...mapMutations([
        'INIT_BUYCART'
      ]),
      toLogin() {
      this.$router.push({ name: 'userLogin' })
      },
      addAddress()
      {        
        this.isAddAddress=true;
      },
      selectAddress(id)
      {  
         if(this.addressId!=id)
         {
           this.addressId=id;
           this.countPostFee();   
         }
      
         for(var i=0;i<this.addList.length;i++)
         {          
            if(this.addList[i].id!=id)
            {
              // this.addList[i].checked=false;
              this.$set(this.addList[i],'checked',false)
            }
            else
            {
              // this.addList[i].checked=true;
              this.$set(this.addList[i],'checked',true)
            }
         }
      },
      async countPostFee()
      {                
          if(this.cartList.length>0)
          {
            var products = [];
            for(var i=0;i<this.cartList.length;i++)
            {
              var temp = this.cartList[i];
               products.push({productId:temp.productId,specId:temp.specId,num:temp.num})
            }
            debugger
            await calculatePostFee({addressId:this.addressId, productList:products }).then(res=>{
                debugger
                if(res&&res.data&&res.data.result)
                {
                  var tempHelpFund=0.00;
                   for(var j=0;j<res.data.result.length;j++)
                   {
                     var tempResult = res.data.result[j];
                     for(var i=0;i<this.cartList.length;i++)
                     {
                        var temp = this.cartList[i];
                        if(temp.specId==tempResult.specId)
                        {
                          this.cartList[i].postFee = tempResult.postFee;  
                          tempHelpFund += tempResult.helpFund;
                        }                       
                     }                    
                   }
                   this.totalHelpFund = tempHelpFund;
                }
            })
          }
      },
      changeDef (item) {
        if (!item.isDefault) {
          item.isDefault = true
          this._addressAddOrUpdate(item)
        }
        return false
      },
      _getVeteran(row)
      {
        this.veteran.veteranId= row.veteranId;
        this.veteran.veteranName = row.veteranName;
        this.veteran.sex = row.sex;
        this.veteran.photo = row.photo;
      },
      selected(data){
        this.msg.province = data.province.value
        this.msg.city = data.city.value
        this.msg.area = data.area.value
      },
      message (m) {
        this.$message.error({
          message: m
        })
      },
      goodsDetails (id) {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },
      async _addressList () {     
        await getAddressList().then(res => {
          if (res.data.success === true) {
            let addList = res.data.result
            console.log(addList)
            this.addList = addList
            addList.forEach(item => {       
            if(item.isDefault||addList.length==1){
              this.addressId = item.id
              item.checked = true;
              setStore('addressInfo',item)     
            }           
            })
          } else {
           this.addList = []
          }
        })        
        
      },
      async _addressAddOrUpdate (params) {
        await createOrEdit(params).then(res => {
          if (res.data.success === true) {
            this._addressList()
            this.update();          
            this.countPostFee()
            this.$message({ message: '操作成功', type: 'success', customClass: 'c-msg' })
          } else {
            this.message(res.message)
          }
        })
      },
      _addressDel (id) {
        Delete({id:id}).then(res => {
          this.$message({ message: '删除成功', type: 'success', customClass: 'c-msg' })
          this._addressList()
          this.countPostFee()
        })
      }, 
      async _selectVeteran()
      {      
        var address = this.addList.find((p) => p.id==this.addressId);
        if(!address)
        {
          this.message('请选择收货地址')   
          return
        }
        this.$refs['selectVeteran'].showSelect(address)  
      },

      // 提交订单后跳转付款页面
      async _submitOrder () {       
        this.loading=true;
        var array = []
        if (this.addressId === '0') {
          this.message('请选择收货地址')       
          this.loading = false
          return
        }
        if (this.cartList.length === 0) {
          this.message('非法操作')       
          this.loading = false
          return
        }
        var isPass=true;
        for (var i = 0; i < this.cartList.length; i++) {
            if(this.cartList[i].num<=0)
            {
              this.message('商品数量必须大于等于0');
               isPass=false;
            }
            array.push(this.cartList[i])
        }
        if(isPass==false)
        {
          this.loading=false;
          return ;
        }
        let params = {
          receiveAddressId:this.addressId,
          cartItems: array,
          isCart:this.isCart,
          name: this.msg.name,
          mobile: this.msg.mobile,
          address: this.msg.address,
          area: this.msg.area,
          province: this.msg.province,
          city: this.msg.city,
          buyerMessage: this.remarks,
          veteranId : this.veteran.veteranId,
          veteranName : this.veteran.veteranName
        }
        await submitOrder(params).then(res => {          
          if (res.data.success === true) {
            this.$message({ message: '订单提交成功', type: 'success', customClass: 'c-msg' })
            removeStore('removeStore')
            this.INIT_BUYCART()
            this.payment(res.data.result)
          } else {
            this.message(res.message)
            this.loading = false
          }
        })
      },
      // 付款
      payment (orderId) {
        this.$router.push({ path: '/order/payment', query: { 'orderId': orderId } })
      },
      async changeProvinceAndCity(province, city) {
        let item = this.provinces.find((p) => p.name == province)
        if (item) {     
        getAreas({ id: item.value }).then((res) => {   
            this.cities = res.data.result.items
            var item1 = this.cities.find((p) => p.name == city)
            if(item1)
            {
              getAreas({ id: item1.value }).then((res1) => {      
                 this.areas = res1.data.result.items
              })     
            }
          })        
        } else {
          this.cities = []
        }      
    },
      async changeProvince(province) {
        let item = this.provinces.find((p) => p.name == province)
        if (item) {     
        getAreas({ id: item.value }).then((res) => {   
            this.cities = res.data.result.items
          })        
        } else {
          this.cities = []
        }
        this.areas = []
        this.msg.city = undefined
        this.msg.area = undefined
    },   
    async changeCity(city) {
        let item = this.cities.find((p) => p.name == city)
        if (item) {
          getAreas({ id: item.value }).then((res) => {      
            this.areas = res.data.result.items
          })           
        } else {
          this.areas = []
        }
        this.msg.area = undefined
    },
    // 修改
    update (item) {
        this.popupOpen = true
        if (item) {
          this.msg.name = item.name
          this.msg.mobile = item.mobile
          this.msg.address = item.address
          this.msg.isDefault = item.isDefault
          this.msg.id = item.id
          this.msg.area = item.area
          this.msg.city = item.city
          this.msg.province = item.province
          this.changeProvinceAndCity(item.province,item.city);
        } else {
          this.msg.name = ''
          this.msg.mobile = ''
          this.msg.address = ''
          this.msg.isDefault = false
          this.msg.id = ''
          this.msg.area = ''
          this.msg.city = ''
          this.msg.province = ''
        }
      },
      // 保存
    save () {
        let p = this.msg
        if(p.name==''||p.name==undefined) 
        {
           this.$message({ message: '收货人姓名不可为空', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.mobile==''||p.mobile==undefined) 
        {
           this.$message({ message: '手机号码不可为空', type: 'error', customClass: 'c-msg' })
           return;
        }
        var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if(!myreg.test(p.mobile))
        {
           this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.province==''||p.province==undefined) 
        {
           this.$message({ message: '请选择省份', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.city==''||p.city==undefined) 
        {
           this.$message({ message: '请选择城市', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.area==''||p.area==undefined) 
        {
           this.$message({ message: '请选择县/区', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.address==''||p.address==undefined) 
        {
           this.$message({ message: '详细地址不可为空', type: 'error', customClass: 'c-msg' })
           return;
        }        
        if (p.id) {
          this._addressAddOrUpdate(p)
        } else {
          delete p.id
          this._addressAddOrUpdate(p)
        }
      },
    //取消保存
    cancelSave()
    {
        this.isAddAddress=false;
    },
    // 删除
    del (id) {
        this._addressDel(id)
      },
      _getCartList () {
      var buyCart = JSON.parse(getStore('cartlist')) 
      this.cartList = [];
      for(var i=0;i<buyCart.length;i++)
      {
        var tempBuyCart = buyCart[i];
        debugger;
         this.cartList.push({
            postFee : 0.00,
            productId:tempBuyCart.productId,
            specId : tempBuyCart.specId,
            name : tempBuyCart.name,
            specNam: tempBuyCart.specName,
            defaultImage: tempBuyCart.defaultImage,
            settlementPrice: tempBuyCart.settlementPrice,
            num : tempBuyCart.num,
            helpFund : tempBuyCart.helpFund
         });
      }      
       this.countPostFee()
      }
    },
    created () {
      if(this.isLogined) 
      {
        this.userId = getStore('userId')
        let query = this.$route.query
        this.productId = query.productId
        this.num = query.num
        this.isCart = query.isCart
        this._getCartList()      
        this._addressList()
        this.countPostFee();
        getAreas({id:null}).then((response) => {      
        this.provinces = response.data.result.items
      })
      }
    },
    mounted() {     
     
    },
    components: { SelectVeteran }
  }
</script>


// WEBPACK FOOTER //
// index.vue?2279b2a4